import { SortSelector } from "@components/common/sort-selector";
import {
  DEFAULT_TEAMS_SORT_BY,
  TEAMS_SORT_BY_MAP,
  TEAMS_SORT_OPTIONS,
} from "@components/teams/teams-constants";
import { getTeamsSortBy } from "@utils/team-utils";
import { TeamsSortBy } from "@custom-types/teams-types";
import type { TeamsSortField } from "@custom-types/teams-types";
import type { SortItem } from "@custom-types/sort-types";

interface Props {
  /** Current sort by value */
  sortBy: TeamsSortBy;

  /** Callback to update the sort by value */
  setSortBy: (sortBy: TeamsSortBy) => void;
}

/** Component to change the teams sort criteria */
export function TeamsSort({ sortBy, setSortBy }: Props): JSX.Element {
  // Fallback to default if sortBy is invalid
  const validSortBy =
    sortBy && TEAMS_SORT_BY_MAP[sortBy] ? sortBy : DEFAULT_TEAMS_SORT_BY;

  /* Handler for sort item change */
  function handleSortChange(newSortItem: SortItem<TeamsSortField>): void {
    const newSortBy = getTeamsSortBy(newSortItem);
    setSortBy(newSortBy);
  }

  return (
    <SortSelector
      sortOptions={TEAMS_SORT_OPTIONS}
      sortItem={TEAMS_SORT_BY_MAP[validSortBy]}
      setSortItem={handleSortChange}
      subjectType="Team"
    />
  );
}
